import { DigitalClock, LocalizationProvider, MultiSectionDigitalClock } from "@mui/x-date-pickers"
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon"
import theme, { padding } from "../../../theme"
import { AccessTime, Close, Opacity } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import { DateTime } from "luxon"
import { ClickOutsideWrapper } from "../ClickOutsideWrapper"

export const CustomTimePicker = ({
    time,
    setTime,
    text,
    setOpen,
    open
    }: {
        time?: DateTime,
        setTime: Function,
        text: string,
        setOpen: Function,
        open: boolean
    }) => {
    return(
        <div style={{ marginBottom: padding * 2, marginTop: padding * 2 }}>
            <ClickOutsideWrapper onClickOutside={() => setOpen(false)}>
                <Box
                    onClick={() => time ? setOpen(!open) : {}}
                    sx = {{
                        height: 40,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "1px #868686 solid",
                        paddingLeft: padding / 4,
                        paddingRight: padding / 4,
                        borderRadius: 1,
                        "&:hover": {
                        cursor: time ? "pointer" : "default",
                        },
                    }}>
                        <AccessTime
                            sx={{
                                opacity: time ? 1 : 0.5,
                                marginRight: '16px'
                            }}/>
                        <Typography sx={{opacity: time ? 1 : 0.5 }}>{time ? time.toFormat('HH:mm'): text }</Typography>

                </Box> 
                {
                    open && (
                        <TimePickerPopup
                            time={time}
                            setTime={setTime}
                            setOpen={setOpen}
                            open={open}/>
                    )
                }
            </ClickOutsideWrapper>

        </div>
    )
}

const TimePickerPopup = ({
    time,
    setTime,
    setOpen,
    open
    }: {
        time?: DateTime,
        setTime: Function,
        setOpen: Function,
        open: boolean
    }) => {
    return (
        <Box
            sx={{
                marginTop: '4px',
                flexDirection: "column",
                display: "flex",
                boxShadow: "2px 2px 10px 0px #868686",
                position: "absolute",
                backgroundColor: "white",
                zIndex: 10,
                borderRadius: '2px',
                            
            }}>
            <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="gb-en">
                <Close
                    sx={{
                        borderRadius: 2,
                        color: theme.palette.background.default,
                        margin: padding / 8,
                        flexDirection: "row",
                        alignSelf: "end",
                        "&:hover": {
                        cursor: "pointer",
                        bgcolor: theme.palette.background.default,
                        color: "white",
                        },
                    }}
                    onClick={() => setOpen(false)}
                />
                <MultiSectionDigitalClock
                    ampm={false}
                    onChange={(time) => setTime(time)}
                    defaultValue= {time}
                    />
            </LocalizationProvider>

        </Box>

    )

}
